import { isValidPhone, isValidPostalCode } from 'utility/countries';

export function name(name) {
    return name.trim() !== '' ? true : false;
}

export function email(email) {
    if (email === null || email === '') {
        return false;
    } else if (email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
        if (email.slice(-4) === '.con') {
            return false;
        }
        return true;
    } else {
        return false;
    }
}

export function address(address) {
    return address.trim() !== '' ? true : false;
}

export function city(city) {
    return city.trim() !== '' ? true : false;
}

export function postalCode(postalCode, region) {
    return isValidPostalCode(postalCode, region);
}

export function select(select) {
    return select !== '';
}

export function phone(phone, countryCode) {
    return isValidPhone(phone, countryCode);
}
